import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_grid _grid-cols-2 _grid-cols-4--m _gap-4 _gap-6--m _tac _jc-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_values_section_item = _resolveComponent("values-section-item")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, { huge: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.marketingServicesValues, (value) => {
          return (_openBlock(), _createBlock(_component_values_section_item, _mergeProps({
            key: value.valueID
          }, { ref_for: true }, value), null, 16 /* FULL_PROPS */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}